import {Component, ElementRef, Inject, OnInit, Renderer2, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ImageType} from '../../../core/helpers/utilities';
import {MatIconModule} from '@angular/material/icon';

@Component({
  selector: 'app-image-viewer',
  standalone: true,
  imports:[
    MatIconModule
  ],
  templateUrl: './image-viewer.component.html',
  styleUrls: ['./image-viewer.component.scss']
})
export class ImageViewerComponent implements OnInit {
  // @Input() imageSrc = ''; // URL de la imagen
  zoom = 1; // Nivel inicial de zoom
  rotation = 0; // Rotación inicial
  offsetX = 0; // Desplazamiento X
  offsetY = 0; // Desplazamiento Y
  imageType: ImageType;

  @ViewChild('imageElement') imageElement!: ElementRef<HTMLImageElement>;
  @ViewChild('container') container!: ElementRef<HTMLDivElement>;

  constructor(
    private renderer: Renderer2,
    public dialogRef: MatDialogRef<ImageViewerComponent>,
    @Inject(MAT_DIALOG_DATA) public image: ImageType
  ) {
    this.imageType = image;
  }

  ngOnInit(): void {
    this.updateTransform();
  }

  close() {
    this.dialogRef.close();
  }


  zoomIn() {
    this.zoom += 0.1;
    this.updateTransform();
  }

  zoomOut() {
    this.zoom = Math.max(0.1, this.zoom - 0.1);
    this.updateTransform();
  }

  rotate() {
    this.resetPosition();
    this.rotation = (this.rotation + 90) % 360;
    this.updateTransform();

  }

  updateTransform() {
    const transformValue = `scale(${this.zoom}) rotate(${this.rotation}deg)`;
    this.renderer.setStyle(this.imageElement.nativeElement, 'transform', transformValue);
    this.renderer.setStyle(this.imageElement.nativeElement, 'max-width', '100%');
    this.renderer.setStyle(this.imageElement.nativeElement, 'max-height', '100vh');
    this.renderer.setStyle(this.imageElement.nativeElement, 'object-fit', 'contain'); // Evita distorsión.
  }


  expand() {
    // Detectar el elemento en pantalla completa (moderno y antiguos)
    const fullscreenElement =
      (document as any).fullscreenElement ||
      (document as any).webkitFullscreenElement ||
      (document as any).mozFullScreenElement ||
      (document as any).msFullscreenElement;

    if (fullscreenElement) {
      // Salir del modo pantalla completa
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if ((document as any).webkitExitFullscreen) {
        (document as any).webkitExitFullscreen();
      } else if ((document as any).mozCancelFullScreen) {
        (document as any).mozCancelFullScreen();
      } else if ((document as any).msExitFullscreen) {
        (document as any).msExitFullscreen();
      }
    } else {
      // Entrar al modo pantalla completa
      const requestFullscreen =
        this.container.nativeElement.requestFullscreen ||
        (this.container.nativeElement as any).webkitRequestFullscreen ||
        (this.container.nativeElement as any).mozRequestFullScreen ||
        (this.container.nativeElement as any).msRequestFullscreen;

      if (requestFullscreen) {
        requestFullscreen.call(this.container.nativeElement);
      }
    }
  }


  onMouseMove(event: MouseEvent) {
    if (this.zoom > 1) {
      const rect = this.container.nativeElement.getBoundingClientRect();
      const offsetX = (event.clientX - rect.left) / rect.width;
      const offsetY = (event.clientY - rect.top) / rect.height;

      this.renderer.setStyle(
        this.imageElement.nativeElement,
        'transform-origin',
        `${offsetX * 100}% ${offsetY * 100}%`
      );
    }
    this.updateTransform();
  }

  resetPosition() {
    this.offsetX = 0;
    this.offsetY = 0;
    this.renderer.setStyle(this.imageElement.nativeElement, 'transform-origin', 'center center');
  }


  reset() {
    this.zoom = 1; // Restablecer el zoom
    this.rotation = 0; // Restablecer la rotación
    this.resetPosition();
    this.updateTransform(); // Aplicar la transformación inicial
  }
}
